import {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router';
import './Stylesheets/Admin.css';



export default function AdminControlPanel(){

    const [selectedTab, setSelectedTab] = useState<string>('posts');

    const [msg, setMsg] = useState<any>({});

    interface Post { postId: number | string; imageUrl?: string; [key: string]: any; postTitle?: string; postBody?: string;}
    const [postsContent, setPostsContent] = useState<Post[]>([]);

    const navigate = useNavigate();

    const backend_url = process.env.REACT_APP_BACKEND_URL;

    // validate user session
    useEffect(() => {
        // GET Post to process sesssion
        axios.get(`${backend_url}/Login/ProcessSession`, {withCredentials: true})
        .then(res => {
            console.log("valid session")
        })
        .catch((error) => {
            console.log(error.response?.status);
            if ( error.response?.status === 401){
                navigate('/adminlogin');
            }
        })
    }, [])


    const categories : { [key: string]: number } = {"Photo Manipulation" : 1, "Photography" : 2, "Illustration" : 3, "Publications" : 4, "Logos" : 5};

    const [selectedWork, setSelectedWork] = useState<Post | null>(null);

    const workOverlayRef = useRef<HTMLDivElement>(null);

    const [selectedCategory, setSelectedCategory] = useState<string | null>("Photo Manipulation");  

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const retrievePosts = (categoryId: number) => {
        setPostsContent([]); // Clear previous posts content
        setIsLoading(true);
        axios.get(`${backend_url}/Blog/GetCategoryPosts/${categoryId}?pageNumber=0`, {withCredentials: true})
        .then(res => setPostsContent(res.data.content))
        .finally(() => {
            setIsLoading(false);
            console.log(postsContent);
        })
    }

    useEffect(() => {
        if(selectedCategory){
            retrievePosts(categories[selectedCategory]);
        }
    }, [selectedCategory]);
    

    const processWorkChange = (e: React.FormEvent<HTMLFormElement>, work: Post) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const updatedWork = {
            postId: work.postId,
            postTitle: formData.get('work-title') as string,
            postBody: formData.get('work-body') as string
        }
        // Post request to update work
    }

    const processWorkDelete = (work: Post) => {

        // Close the overlay
        setSelectedWork(null); 

        // Trigger Loading
        setIsLoading(true);

        // Clear posts content
        setPostsContent([]);

        // Post request to delete work
        axios.post(`${backend_url}/Blog/DeletePost/${work.postId}`, {}, {withCredentials: true})
        .finally(() => {
            // Reprocess retrieval of posts 
            retrievePosts(categories[selectedCategory!]);
            }
        )



    }

    const renderOverlay = (work: Post) => {
        return (
            <div className={"work-overlay"}>
                <div className={"admin-work-div"}>
                    <img src={work.imageUrl} alt={work.postTitle} />
                    <div className={"work-details"}>
                        <form onSubmit={(e) => processWorkChange(e, work)}>
                            <input type={"text"} value={work.postTitle} name={"work-title"}/>
                            <textarea name={"work-body"} value={work.postBody}></textarea>
                            <div>
                                <button type={"submit"}>Save Changes</button>
                                <button type={"submit"} onClick={() => processWorkDelete(work)}>Delete Work</button>
                                <button type={"button"} onClick={() => setSelectedWork(null)}>Close</button>
                            </div>
                            
                        </form>
                    </div>
                </div>

            </div>
        )
    }
    const renderContent = () => {

        switch(selectedTab){
            case "posts":
                return (
                    <div className={'admin-control-posts'}>
                       <div className={'admin-control-posts-categories'}>
                            {Object.keys(categories).map((category) => (
                                <button className={selectedCategory === category ? 'admin-control-posts-category active' : 'admin-control-posts-category'} onClick={() => setSelectedCategory(category)} key={category}>
                                    {category}
                                </button>
                            ))}
                            <a href="/createpost">Create New Post</a>
                       </div>
                       {isLoading && <h2>Loading...</h2>}
                       {!isLoading && selectedCategory && postsContent.length > 0 &&(
                        <div className={'admin-control-posts-content'}>
                            {postsContent.map((e) => (
                                <div onClick={() => setSelectedWork(e)} key={e.postId} className="admin-control-post-item">
                                    <img className={"admin-control-post-image"} src={e.imageUrl}/>
                                </div>
                            ))}
                        </div>
                       )}
                    </div>
                )
            case "accounts":
                return (
                    <div className={'admin-control-accounts'}>
                        <h2>Manage Accounts</h2>
                    </div>
                )
        }
    }



    return(

        <>

        <div className={'admin-control-panel-main-div'}>
            <h1>Admin Control Panel</h1>
            <div className={'admin-control-panel-content-div'}>
                <nav className={'admin-control-panel-nav'}>
                    <ul className={'admin-control-panel-ul'}>
                        <button className={selectedTab === "posts" ? 'admin-control-panel-btn active' : 'admin-control-panel-btn'} onClick={() => setSelectedTab("posts")}>Manage Posts</button>
                        <button className={selectedTab === "accounts" ? 'admin-control-panel-btn active' : 'admin-control-panel-btn'} onClick={() => setSelectedTab("accounts")}>Manage Accounts</button>
                    </ul>
                </nav>
                <div className={'admin-control'}>
                    {renderContent()}
                </div>
            </div>


        </div>
        
        {selectedWork && renderOverlay(selectedWork)}

        </>
    )
}